'use strict';

export { default } from './table.factory';